import { LogLevel } from "@azure/msal-browser";

export const msalConfig = {
    auth: {
        clientId: '458d8856-5cd4-4d7f-b154-4b6f1cd64e17',
        authority: 'https://alignorgexternal.ciamlogin.com/',
        redirectUri: process.env.REACT_APP_URL,
        postLogoutRedirectUri: process.env.REACT_APP_URL,
        navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
        cacheLocation: 'localStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};

export const loginRequest = {
    scopes: [ "api://align-org-backend/access_as_user" ],
};